export const categories = [
  {
    id: "news",
    name: "资讯",
    icon: "ri-newspaper-line",
    desc: "实时新闻、热点资讯与深度报道平台，第一时间掌握国内外动态。",
    subcategories: ["综合门户", "时政要闻", "财经资讯", "国际媒体"],
  },
  {
    id: "video",
    name: "视频",
    icon: "ri-play-circle-line",
    desc: "影视、综艺、番剧与短视频平台，追剧娱乐一站直达。",
    subcategories: ["综合视频", "短视频", "影视剧集", "海外视频"],
  },
  {
    id: "shopping",
    name: "购物",
    icon: "ri-shopping-bag-3-line",
    desc: "综合电商与品牌商城，比价选购、正品好物轻松购。",
    subcategories: ["综合电商", "品牌商城", "拼团特卖", "海外购物"],
  },
  {
    id: "education",
    name: "教育",
    icon: "ri-graduation-cap-line",
    desc: "在线课程、公开课与学习平台，助力自我提升与技能成长。",
    subcategories: ["在线课程", "名校公开课", "语言学习", "职业培训"],
  },
  {
    id: "tools",
    name: "工具",
    icon: "ri-tools-line",
    desc: "翻译、笔记、协作与效率工具，办公学习必备的实用集合。",
    subcategories: ["翻译工具", "云笔记", "在线协作", "效率应用"],
  },
  {
    id: "social",
    name: "社交",
    icon: "ri-chat-smile-2-line",
    desc: "社交平台与兴趣社区，分享观点、发现同好、交流互动。",
    subcategories: ["社交微博", "知识问答", "兴趣社区", "海外社区"],
  },
  {
    id: "finance",
    name: "财经",
    icon: "ri-line-chart-line",
    desc: "财经资讯与行情数据平台，投资理财信息一目了然。",
    subcategories: ["财经门户", "股票行情", "投资社区", "国际金融"],
  },
  {
    id: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    desc: "游戏发行、社区与资讯平台，发现与下载热门游戏。",
    subcategories: ["游戏平台", "手游社区", "游戏商城", "游戏资讯"],
  },
  {
    id: "life",
    name: "生活",
    icon: "ri-live-line",
    desc: "点评、出行与本地生活服务，吃喝玩乐出行全搞定。",
    subcategories: ["生活服务", "旅行出行", "地图导航", "房产家居"],
  },
  {
    id: "dev",
    name: "编程",
    icon: "ri-code-s-slash-line",
    desc: "代码托管、技术社区与问答平台，开发者的日常工具箱。",
    subcategories: ["代码托管", "技术社区", "问答社区", "开源平台"],
  },
];